import {
  Box,
  Container,
  Divider,
  List,
  ListItem,
  Stack,
  styled,
  Typography,
} from "@mui/material";

type NavLinkArray = {
  title: string;
  path: string;
}[];

const data = {
  Overview: [
    {
      type: "para",
      data: "It is a two year full time programme consisting of classroom teaching, self-academic activities and clinical postings, with self-directed evidence based practice. The curriculum is to train the students to excel in academic skills, evidence-based and ethical practice in all the areas of physiotherapy care.",
    },
  ],
  "Eligibility Criteria": [
    {
      type: "para",
      data: "Bachelor's degree in Physiotherapy from a recognized university with a minimum of 50 % marks in Bachelor of Physiotherapy.",
    },
  ],
  Specialities: [
    {
      type: "nav-tab",
      data: [
        {
          title: "MPT in Musculoskeletal physiotherapy",
          path: "/department/musculoskeletal-physiotherapy",
        },
        {
          title: "MPT in Neuro physiotherapy",
          path: "/department/neuro-physiotherapy",
        },
        {
          title: "MPT in Cardiovascular &  Respiratory Physiotherapy",
          path: "/department/cardiovascular-&-respiratory-physiotherapy",
        },
        {
          title: "MPT in Community Physiotherapy",
          path: "/department/community-physiotherapy",
        },
      ],
    },
  ],

  "Admission Process": [
    {
      type: "unordered-list",
      data: {
        "1": "Admissions are centralised through the Directorate of Medical Education and Research, Mumbai, under the Maharashtra Govt.",
        "2": "After the PGP-CET result is declared, registration to the government website is mandatory.",
        "3": "Candidates apply to the college through the preference forms available on the DMER website.",
        "4": "Based on their preference, eligible candidates' names are assigned to the college.",
        "5": "Candidates confirm their admission by duly filling the college form issued with the prospectus.",
        "6": "The process is completed with providing the necessary, original documentation to the college.",
        "7": "Fees are to be paid in full at the time of admission.",
      },
    },
  ],
  "Documents Required": [
    {
      type: "ordered-list",
      data: {
        "1": "PGP-CET Admit Card of PG Exam and score card",
        "2": "PGP-CET Application (Registration) Form",
        "3": "Allotment Letter issued from DMER",
        "4": "Any Photo ID Proof Xerox (Aadhar Card, Pan Card, Passport)",
        "5": "Nationality Certificate issued by District Magistrate OR Attested Valid Indian Passport indicating the Nationality of the Candidate as 'INDIAN'",
        "6": "Domicile Certificate issued by District Magistrate endorsed with nationality as Indian on it.",
        "7": "HSC (Higher Secondary) Statement of Mark Sheet & Certificate",
        "8": "SSC Passing Certificate for Birth Date",
        "9": "First to Fourth Year B.P.Th. Marksheets",
        "10": "Internship Completion Certificate",
        "11": "Passing Certificate",
        "12": "B.P.Th. Degree Certificate",
        "13": "Attempt Certificate",
        "14": "OT/PT Certificate",
        "15": "Aadhar Card",
        "16": "Caste Certificate",
        "17": "Caste Validity Certificate",
        "18": "Valid Non-Creamy Layer Certificate for VJ, NT-1, NT-2, NT-3, OBC, SBC",
        "19": "College Leaving Certificate (LC/TC)",
        "20": "Copy of Gazette for Change in Name (If Applicable)",
        "21": "Migration Certificate issued by the respective Board/University (If Applicable)",
        "22": "Affidavit Gap Certificate (If Applicable)",
        "23": "Medical Fitness Certificate on Doctor's Letterhead",
        "24": "Physically Handicapped Certificate",
        "25": "D.D. in favor of PES Modern College of Physiotherapy, Pune-5",
      },
    },
  ],
};

const RomanList = styled(List)(({ theme }) => ({
  listStyleType: "none",
  counterReset: "roman-counter",
  paddingLeft: 0,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up("md")]: {
    marginLeft: theme.spacing(10),
  },

  "& li": {
    counterIncrement: "roman-counter",
    position: "relative",
    paddingLeft: "48px",
    textIndent: "8px",
    marginBottom: theme.spacing(1),
  },
  "& li::before": {
    content: 'counter(roman-counter, upper-roman) ". "',
    position: "absolute",
    left: 0,
    top: "50%",
    transform: "translateY(-50%)",
    fontWeight: "bold",
    width: "auto",
    height: "auto",
    marginRight: "8px",
    textAlign: "right",
  },
}));

const AdmissionProcedureMPT = () => {
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 2, md: 3 } }}
        spacing={2}
      >
        <Container sx={{ pt: 2 }}>
          {Object.entries(data).map(([section, items], index) => {
            return (
              <div key={section + index} style={{ paddingTop: "16px" }}>
                <div style={{ marginBottom: "24px" }}>
                  <Typography
                    variant="h4"
                    gutterBottom
                    sx={{
                      display: "inline",
                      textDecoration: "underline",
                      textUnderlineOffset: "6px",
                    }}
                  >
                    {`${section}`}
                  </Typography>{" "}
                  <Typography
                    variant="h4"
                    sx={{ display: "inline" }}
                    gutterBottom
                  >
                    :
                  </Typography>
                </div>
                {items.map((item, index) => {
                  if (item.type === "para") {
                    return (
                      <Typography
                        key={item.type + item.data}
                        paragraph
                        fontSize={16}
                        sx={{ marginLeft: { sx: 2, md: 10 } }}
                      >
                        {typeof item.data === "string" ? item.data : ""}
                      </Typography>
                    );
                  } else if (item.type === "unordered-list") {
                    return (
                      <List
                        key={item.type + index}
                        sx={{
                          marginLeft: { sx: 2, md: 10 },
                          listStyleType: "none",
                          paddingLeft: 0,

                          "& li": {
                            position: "relative",
                            paddingLeft: "24px",
                          },
                          "& li::before": {
                            content: '""',
                            position: "absolute",
                            left: 0,
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: "6px",
                            height: "6px",
                            borderRadius: "50%",
                            backgroundColor: "currentColor",
                          },
                        }}
                      >
                        {Object.values(item.data).map((listItem, i) => (
                          <ListItem
                            key={listItem + i}
                            sx={{ display: "flex", alignItems: "center" }}
                          >
                            {listItem}
                          </ListItem>
                        ))}
                      </List>
                    );
                  } else if (item.type === "nav-tab") {
                    const ObjectArray = item.data as NavLinkArray;
                    return (
                      <List
                        key={index.toString() + item.type}
                        sx={{
                          marginLeft: { sx: 2, md: 10 },
                          listStyleType: "none",
                          paddingLeft: 0,
                          "& li": {
                            position: "relative",
                            paddingLeft: "24px",
                          },
                          "& li::before": {
                            content: '""',
                            position: "absolute",
                            left: 0,
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: "4px",
                            height: "4px",
                            borderRadius: "50%",
                            backgroundColor: "currentColor",
                          },
                        }}
                      >
                        {ObjectArray?.map((listItem, i) => (
                          <ListItem
                            key={listItem.title}
                            sx={{ display: "flex", alignItems: "center" }}
                          >
                            <a
                              style={{ textDecoration: "none" }}
                              href={listItem.path}
                              rel="noopener noreferrer"
                            >
                              {`${listItem.title}  >>`}
                            </a>
                          </ListItem>
                        ))}
                      </List>
                    );
                  } else if (item.type === "ordered-list") {
                    return (
                      <RomanList key={item.type + index}>
                        {Object.values(item.data).map((listItem, i) => (
                          <ListItem key={listItem + i}>{listItem}</ListItem>
                        ))}
                      </RomanList>
                    );
                  } else {
                    return null;
                  }
                })}
                <Divider sx={{ marginY: 2 }} />
              </div>
            );
          })}
        </Container>
      </Stack>
    </Box>
  );
};

export default AdmissionProcedureMPT;
